// extracted by mini-css-extract-plugin
export default {"calloutSection":"CalloutSection_calloutSection__a9Dzn","calloutImage":"CalloutSection_calloutImage__kcZFg","calloutText":"CalloutSection_calloutText__Nb9JT"};